import { render, staticRenderFns } from "./invoicePayments.vue?vue&type=template&id=94cca1e6"
import script from "./invoicePayments.vue?vue&type=script&lang=js"
export * from "./invoicePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports